import React, { useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import AttributeProp from '../propTypes/attributeProp';
import CategoryProp from '../propTypes/categoryProp';
import ShopCategoryDropdown from '../ShopCategoryDropdown';

function ShopSubMenu({
  catalogTypes,
  categories,
  query,
  handleQueryChange,
  t,
}) {
  const [selectedProductType, setSelectedProductType] = useState(
    catalogTypes[0]?.catalogType ?? null,
  );

  const checkForActive = catalog =>
    selectedProductType === catalog.catalogType ||
    query.productType === catalog.catalogType;

  return (
    <div className="m-portlet m-portlet--rounded m-portlet--rounded-force m--margin-bottom-10 shopSubMenu">
      <div className="m-portlet__body category-bar">
        <div className="row no-padding shop-submenu">
          <div className="col-12 no-padding">
            <div className="shop-submenu-container px-5">
              <ul className="shop-submenu-lis">
                {catalogTypes.map(catalog => (
                  <li
                    className="catalogTypeItem"
                    onMouseLeave={() => setSelectedProductType(null)}
                  >
                    <button
                      type="button"
                      className={`clickable dropdownHover ${
                        checkForActive(catalog) ? 'active' : ''
                      }`}
                      onClick={() =>
                        handleQueryChange({
                          productType: catalog.catalogType,
                          category: '',
                        })
                      }
                      onMouseEnter={() =>
                        setSelectedProductType(catalog.catalogType)
                      }
                    >
                      {catalog.name}
                    </button>
                    <ShopCategoryDropdown
                      t={t}
                      query={query}
                      productType={catalog.catalogType}
                      handleQueryChange={handleQueryChange}
                      categories={categories.filter(category =>
                        (category.catalogTypes || []).includes(
                          catalog.catalogType,
                        ),
                      )}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ShopSubMenu.propTypes = {
  catalogTypes: PropTypes.arrayOf(
    PropTypes.shape({
      catalogType: PropTypes.string,
      total: PropTypes.number,
    }),
  ).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  query: PropTypes.shape({
    category: PropTypes.string,
    maxPrice: PropTypes.number,
    attributes: PropTypes.shape(AttributeProp.propType),
    sort: PropTypes.number,
    search: PropTypes.number,
    productType: PropTypes.string,
  }).isRequired,
  handleQueryChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate(ShopSubMenu);
